<template>
  <a
    :href="linkHref"
    :class="c_class"
    @click.prevent="openModal"
  >
    <slot />
  </a>
</template>

<script>
export default {
  props: {
    to: {
      type: String,
      required: true,
    },
    tag: {
      type: String,
      default: 'a',
    },
    activeClass: {
      type: String,
      default: 'active',
    },
  },
  computed: {
    // Generate href for accessibility
    linkHref() {
      const queryObj = new URLSearchParams({
        page: this.to,
      })

      return `?${queryObj.toString()}`
    },
    c_class() {
      return {
        [this.activeClass]: this.isActive,
        'nuxt-link-exact-active': this.isActive,
        'nuxt-link-active': this.isActive,
      }
    },
    isActive() {
      return (
        this.$route.query.page === this.to
      )
    },
  },
  methods: {
    openModal() {
      this.$modal.open({ page: this.to })
    },
  },
}
</script>
